<template>
  <TWModal
      :title="$t('users.userDetails')"
      :show="show"
      :loading="false"
      @close="handleClose"
      :allow-outside-click-to-close="false"
  >
    <div slot="content">
      <tabs :tab-list="{general: $t('users.general'), security: $t('users.security')}">
          <div slot="general" data-test="user-general-tab">
            <form>
              <div>
                <div class="mb-4">
                  <label class="mb-1 inline-block">{{ $t('users.name') }}</label>
                  <p>{{ user.name }}</p>
                </div>
                <div class="mb-4">
                  <label class="mb-1 inline-block">{{ $t('users.email') }}</label>
                  <p>{{ user.email }}</p>
                </div>
                <div class="mb-4">
                  <label class="mb-1 inline-block">{{ $t('users.role') }}</label>
                  <p>{{ $t(`users.roles.${user.role}`) }}</p>
                </div>
                <div class="mb-2">
                  <label class="mb-1 inline-block">{{ $t('users.teams') }}</label>
                  <p>
                    <span>{{ formatUserGroups(user.groups) }}</span>
                  </p>
                </div>
                <div class="mb-2">
                  <label class="mb-1 inline-block">{{ $t('functional.created') }}</label>
                  <p>{{ user.created_at | formatDate('timestamp') }}</p>
                </div>
              </div>
            </form>
          </div>
          <div slot="security" v-if="userHasRole('super-admin')" data-test="user-security-tab">
            <user-mfa :user="selectedUser" />
            <label class="mb-2 block">{{ $t('users.password')}}</label>
            <button
                type="button"
                class="tw-button tw-button-cta mb-1.5 mr-2 w-full sm:w-auto"
                id="reset-user-password-button"
                @click="handleOpeningResetPasswordModal"
                data-ec="view_user_modal"
                data-et="btn_open_password_reset_modal">
              <span>{{ $t('users.resetPassword') }}</span>
            </button>
          </div>
      </tabs>
    </div>

    <div slot="controls" class="w-full md:flex md:justify-between">
      <div class="">
        <button
            type="button"
            id="cancel-view-user-button"
            class="tw-button mr-2 w-full mb-1.5 sm:w-auto"
            @click="handleCancelButtonClicked"
            data-ec="view_user_modal"
            data-et="btn_cancel">
          <span>{{ $t('functional.done') }}</span>
        </button>
      </div>
      <div class="md:justify-items-end md:items-end">
        <button
            type="button"
            class="tw-button tw-button-error mb-1.5 mr-2 w-full sm:w-auto"
            id="delete-user-button"
            @click="handleOpeningDeleteUserModal"
            data-ec="view_user_modal"
            data-et="btn_open_delete_modal">
          <icon name="trash" />
          <span>{{ $t('users.deleteUser') }}</span>
        </button>
        <button
            type="button"
            id="edit-user-button"
            class="tw-button tw-button-cta w-full sm:w-auto"
            @click="handleOpeningEditUserModal"
            data-ec="view_user_modal"
            data-et="btn_open_edit_user_modal">
          <icon name="edit" />
          <span>{{ $t('users.edit') }}</span>
        </button>
      </div>
    </div>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import { mapGetters } from 'vuex';
import formatUserGroupsMixin from '@/mixins/formatUserGroups';
import Tabs from '@/components/tailwind/Tabs.vue';
import UserMfa from '@/components/UserMfa.vue';

export default {
  name: 'ViewUserModal',
  props: {
    selectedUser: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [formatUserGroupsMixin],
  components: {
    UserMfa,
    Tabs,
    TWModal,
  },
  data() {
    return {
      user: { ...this.selectedUser },
    };
  },
  computed: {
    ...mapGetters({
      authenticatedUser: 'user/user',
      featureEnabled: 'featureFlags/featureEnabled',
      userHasRole: 'roles/userHasRole',
    }),
  },
  watch: {
    selectedUser: {
      deep: true,
      handler(newVal) {
        this.user = { ...newVal };
      },
    },
  },
  methods: {
    handleCancelButtonClicked() {
      this.handleClose();
    },
    handleClose() {
      // Reset the component to the initial state when created
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$emit('close');
    },
    handleOpeningDeleteUserModal() {
      this.handleClose();
      this.$emit('delete-user');
    },
    handleOpeningResetPasswordModal() {
      this.handleClose();
      this.$emit('reset-user-password');
    },
    handleOpeningEditUserModal() {
      this.handleClose();
      this.$emit('edit-user');
    },
  },
};
</script>

<style scoped>

</style>
